import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import NuiIntlProviderLite from '@concur/nui-intl/lib/components/NuiIntlProviderLite';
import { getLocaleData } from '@concur/nui-intl/lib/pure/getLocaleData';
import getLanguage from '@concur/nui-intl/lib/server/getLanguage';

export default (WrappedComponent) => {
    const Component = ({ testMessages, ...props }) => {
        const [messages, setMessages] = useState(testMessages);

        const name = WrappedComponent.displayName || WrappedComponent.name;
        Component.displayName = name || 'withNuiIntl';

        useLayoutEffect(() => {
            let didCancel = false;
            const fetchMessagesFile = async () => {
                const langCode = getLanguage(props.lang);
                let messagesFile;
                try {
                    messagesFile = await import(/* webpackChunkName: "translations/ui-floorplans-[request]" */ `../translations/${langCode}`);
                } catch (e) {
                    messagesFile = await import(/* webpackChunkName: "translations/ui-floorplans-[request]" */ '../translations/en');
                }
                if (!didCancel) { // Ignore the file if the lang changes quickly
                    setMessages(messagesFile.default);
                }
            };
            if (!testMessages) {
                fetchMessagesFile();
            }
            return () => { didCancel = true; };
        }, [props.lang]);

        if (!messages) {
            return <WrappedComponent {...props} />;
        }

        const nuiIntlProps = {
            localeData: {
                lang: props.lang,
            },
        };
        const localeData = getLocaleData(nuiIntlProps);

        return (
            <NuiIntlProviderLite messages={messages} localeData={localeData}>
                <WrappedComponent {...props} />
            </NuiIntlProviderLite>
        );
    };

    hoistNonReactStatics(Component, WrappedComponent);
    Component.propTypes = {
        lang: PropTypes.string,
        testMessages: PropTypes.object, // Only used for Jest tests
    };

    Component.defaultProps = {
        lang: 'en',
    };
    return Component;
};
